import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { BxNavigationModule } from '@core/components/navigation';
import { cbConfigMenuModule } from "app/layout/components-common/config-menu-cb/config-menu-cb.module"
import { ExecutiveModule } from "app/layout/components-common/executive/executive.module"
import { cbHomeMenuModule } from 'app/layout/components-common/home-menu-cb/home-menu-cb.module';

import { UserModule } from 'app/layout/components-common/user/user.module';
import { SharedModule } from 'app/shared/shared.module';
import { ShowIndexesModule } from '@core/components/show-ticker/show-ticker.module';
import { ModernLayoutComponent } from 'app/layout/layouts/horizontal/modern/modern.component';
import { MessagesModule } from 'app/layout/components-common/messages/messages.module';
import { NotificationsModule } from 'app/layout/components-common/notifications/notifications.module';
import { FooterComponent } from 'app/modules/site/footer/footer.component';
@NgModule({
    declarations: [
        ModernLayoutComponent
    ],
    imports: [
        HttpClientModule,
        FooterComponent,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        BxNavigationModule,
        ExecutiveModule,
        cbConfigMenuModule,
        cbHomeMenuModule,
        UserModule,
        SharedModule,
        ShowIndexesModule,
        MessagesModule,
        NotificationsModule,
    ],
    exports: [
        ModernLayoutComponent
    ]
})
export class ModernLayoutModule {
}
